import { render, staticRenderFns } from "./credit-repair-case.vue?vue&type=template&id=2f03d950"
import script from "./credit-repair-case.vue?vue&type=script&lang=ts"
export * from "./credit-repair-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports